import { Box, Paper, Typography, useTheme } from "@mui/material";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { useCohortDetails } from "./useCohortDetails";

interface InfoFieldProps {
  label: string;
  value: string;
}

function InfoField({ label, value }: InfoFieldProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: 0.5,
        minHeight: "32px",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 400,
          minWidth: "180px",
          mr: 2,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.primary,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export function CurrentWorkflow() {
  const theme = useTheme();
  const { data } = useCohortDetails();

  const cohort = data?.cohort;

  if (!cohort?.currentWorkflow) {
    return null;
  }

  return (
    <Paper
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        p: 2,
      }}
      elevation={0}
    >
      <Typography
        variant="h6"
        fontWeight="600"
        sx={{ mb: 1.5, color: theme.palette.text.primary }}
      >
        Current Workflow
      </Typography>

      <Box>
        <InfoField label="Workflow ID" value={cohort.currentWorkflow.id} />
        <InfoField
          label="Workflow Status"
          value={prettyPrintEnumValue(cohort.currentWorkflow.status)}
        />
        <InfoField
          label="Current Activity"
          value={cohort.currentWorkflow.currentActivity?.type ?? "N/A"}
        />
        <InfoField
          label="Current Activity Assignee"
          value={
            cohort.currentWorkflow.currentActivity?.assignee?.email ?? "N/A"
          }
        />
      </Box>
    </Paper>
  );
}
